import { useContext, useMemo } from 'react';

import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { rollUpHydratedTaskUsers } from '@atom/utilities/userUtilities';

import classes from './workTemplateInfo.module.css';

const WorkTemplateDetails = () => {
  const { workTemplate } = useContext(WorkTemplateContext);

  const hydratedUsers = rollUpHydratedTaskUsers(workTemplate.tasks);

  const teamLead = useMemo(() => {
    return hydratedUsers.find(user => user.id === workTemplate?.leadAssigneeId);
  }, [workTemplate?.leadAssigneeId, hydratedUsers]);

  const teamLeadName = teamLead
    ? `${teamLead?.firstName} ${teamLead?.lastName}`
    : '-';

  return (
    <>
      <div className={classes.sectionHeader}>
        <div>Details</div>
      </div>
      <div className={classes.detailContent}>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Team Lead:</div>
          <div>{teamLeadName}</div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Estimated Cost:</div>
          <div>
            <div>{numberToLocaleString(workTemplate?.estimatedCost)}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkTemplateDetails;
